import React from 'react'
import './SoftwareDevHero.scss'

export class SoftwareDevHero extends React.Component {
  render() {
    return (
      <div
        className="software-dev-page-hero"
        style={{ backgroundImage: 'url(/cloudsecopsbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>Software Development</h1>
            <h2>Elite Engineering Teams Delivering Mission-Critical Solutions</h2>
          </div>
        </div>
      </div>
    )
  }
}

export default SoftwareDevHero
